import { useCallback, useRef, TouchEventHandler, TouchEvent } from "react";

interface IUseHoldHandler {
  onRelease?: () => void;
  onHold?: () => void;
  isHolding: React.MutableRefObject<boolean>;
}

type EmptyCallback = () => void;

type CallbackFunction<Target = Element> = TouchEventHandler<Target> | EmptyCallback;

const DEFAULT_THRESHOLD = 500;

export const useHoldHandler = ({ onHold, onRelease, isHolding }: IUseHoldHandler) => {
  const holdTimer = useRef<NodeJS.Timeout | null>(null);

  const handleTouchStart = useCallback<CallbackFunction<Element>>(
    (e: TouchEvent<Element>) => {
      holdTimer.current = setTimeout(() => {
        isHolding.current = true;
        if (onHold) {
          onHold();
        }
      }, DEFAULT_THRESHOLD);
    }, [onHold, isHolding]);

  const handleTouchEnd = useCallback<CallbackFunction<Element>>(
    (e: TouchEvent<Element>) => {
      if (holdTimer.current) {
        clearTimeout(holdTimer.current);
        holdTimer.current = null;
      }

      if (isHolding.current && onRelease) {
        onRelease();
      }

      setTimeout(() => {
        isHolding.current = false;
      }, 0);
    }, [onRelease, isHolding]);

  return {
    handleTouchStart,
    handleTouchEnd
  };
};
